/**
 * Sprint 33, story-169 (D15). Curated IANA timezone fallback list, used when
 * `Intl.supportedValuesOf('timeZone')` isn't available in the browser. Covers US/CA/MX plus a
 * handful of other commonly used zones. Kept in sync (by name, not file) with mobile's
 * `constants/timezones.ts`.
 */
export const CURATED_TIMEZONES: string[] = [
  'America/New_York',
  'America/Detroit',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'America/Vancouver',
  'America/Winnipeg',
  'America/Edmonton',
  'America/Halifax',
  'America/St_Johns',
  'America/Mexico_City',
  'America/Tijuana',
  'America/Monterrey',
  'America/Cancun',
  'America/Puerto_Rico',
  'America/Bogota',
  'America/Lima',
  'America/Santiago',
  'America/Buenos_Aires',
  'America/Sao_Paulo',
  'America/Guatemala',
  'America/Costa_Rica',
  'America/Panama',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Lisbon',
  'Africa/Johannesburg',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Sydney',
  'Pacific/Auckland',
  'UTC',
];

export function getTimezoneOptions(): string[] {
  try {
    // `Intl.supportedValuesOf` is ES2022 — not in this project's `lib` target yet, hence the cast.
    const intlWithSupportedValuesOf = Intl as unknown as { supportedValuesOf?: (key: string) => string[] };
    if (typeof intlWithSupportedValuesOf.supportedValuesOf === 'function') {
      return intlWithSupportedValuesOf.supportedValuesOf('timeZone');
    }
  } catch {
    // fall through to curated list
  }
  return CURATED_TIMEZONES;
}
